import React from 'react';
import cx from 'classnames';

import { EarningsLegendItem } from './EarningsLegendItem';

interface Props {
    itemsPerRow: number;
    legendSources: EarningsLegendSource[];
    legendDivId: string;
    addClasses?: string;
}

export const EarningsLegend = ({
    itemsPerRow,
    legendDivId,
    legendSources,
    addClasses,
}: Props): JSX.Element => {
    let legendItems = null;
    let numberOfGridRows = 1;

    if (legendSources.length > 0) {
        legendItems = legendSources.map((legendSource: EarningsLegendSource) =>
            EarningsLegendItem(legendSource),
        );

        numberOfGridRows = Math.ceil(legendSources.length / itemsPerRow);
    }

    const gridTemplateColumns = 'auto '.repeat(itemsPerRow).trimEnd();
    const gridTemplateRows = 'auto '.repeat(numberOfGridRows).trimEnd();

    return (
        <div
            id={legendDivId}
            className={cx(
                'earnings-legend flex w-full flex-wrap justify-around',
                addClasses,
            )}
            style={{
                display: 'grid',
                gridTemplateColumns,
                gridTemplateRows,
                alignItems: 'start',
            }}
        >
            {legendItems}
        </div>
    );
};
